<template>
  <div class="reels-wrapper">
    <!-- Top header -->
    <header class="header">
      <a href="/tshaps">
        <img src="https://tshaku.com/view/socialV/assets/images/logo.png" class="img-fluid" alt="" style="height:20px;">
        <span>Tshaps</span>
      </a>
    </header>

    <!-- Reels -->
    <div class="reels-container" ref="containerRef">
      <div
        v-for="(video, index) in videos"
        :key="index"
        class="reel"
        :ref="el => reelRefs[index] = el"
      >
      <div v-if="muteIndicatorVisible" class="mute-indicator" :key="'mute-' + index">
        <span v-if="isMuted">🔇</span>
        <span v-else>🔊</span>
      </div>
        <video
          :src="video.src"
          :muted="isMuted"
          playsinline          
          loop
          preload="metadata"
          class="video"
          @click="handleVideoClick(index)"
          @loadeddata="markVideoLoaded(index)"
        ></video>
        <div v-if="!videoLoaded[index]" class="video-spinner"></div>

        <!-- Overlay -->
        <div class="overlay">
          <div class="action-buttons">
            <button @click.stop="toggleLike(index)">
              <span :class="{ liked: video.liked }">❤️</span>
              <small>1</small>
            </button>
            <button @click.stop="openComment(index)">
              <span>💬</span>
              <small>1</small>
            </button>
            <button @click.stop="shareReel(index)">
              <span>📤</span>
              <small>1</small>
            </button>
          </div>
          <!-- Uploader info -->
          <div class="uploader-info">
            <div class="user">
              <div v-if="video.handle">
                <a :href="'/@' + video.handle">@{{ video.handle }}</a>
              </div>
              <div v-else>
                <a :href="'/profile/' + video.id">{{ video.first_name }} {{ video.last_name }}</a>
              </div>              
              <button class="follow-btn">Follow</button>
            </div>
            <p class="caption">{{ video.caption }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom nav -->
    <nav class="bottom-nav">
      <button @click="goTo('home')">🏠</button>
      <button @click="goTo('search')">🔍</button>
      <button @click="openAddTshapModal">➕</button>
      <button @click="goToProfile(id)">
        <img class="avatar" :src="avatar" alt="Profile" />
      </button>
    </nav>

    <!-- Modal for adding Tshap -->
    <div v-if="isAddModalOpen" class="modal">
      <div class="modal-content">
        <h2>Upload a New Tshap</h2>
        <input type="file" @change="handleFileChange" accept="video/*" />
        <textarea v-model="newTshapCaption" placeholder="Write a caption..."></textarea>
        <button @click="uploadTshap">Upload</button>
        <button @click="closeAddTshapModal">Cancel</button>
        <div v-if="isUploading" class="spinner"></div>
      </div>
    </div>
    <!-- Comments Panel -->
    <div v-if="activeCommentIndex !== null" class="comments-panel">
      <div class="comments-header">
        <h3>Comments</h3>
        <button class="close-comments" @click="closeComment">✕</button>
      </div>
      <div class="comments-body">
        <p>No comments yet for this Tshap.</p>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router';
import { ref, onMounted, nextTick, onBeforeUnmount } from 'vue';

export default {
  data() {
    return {
      currentIndex: 0,
      reelRefs: [],
      containerRef: null,
      videos: [],
      lastTouchY: 0,
      isAddModalOpen: false,
      selectedFile: null,
      newTshapCaption: '',
      isUploading: false,
      isMuted: true, // <--- NEW: track mute state
      muteIndicatorVisible: false,
      muteTimeout: null,
      activeCommentIndex: null,
      videoLoaded: [], // one entry per video
    };
  },
  computed: {
    f_name(){
      return this.$store.state.firstName
    },
    l_name(){
      return this.$store.state.lastName
    },
    id() {
      return this.$store.state.userId;
    },
    avatar() {
      return this.$store.state.avatar;
    },
  },
  methods: {
    openComment(index) {
      this.activeCommentIndex = index;
    },
    closeComment() {
      this.activeCommentIndex = null;
    },
    handleVideoClick(index) {
      this.isMuted = !this.isMuted; // Toggle mute state
      // Update all currently loaded videos
      this.reelRefs.forEach((el) => {
        const video = el?.querySelector('video');
        if (video) video.muted = this.isMuted;
      });
      // Show mute/unmute indicator briefly
      this.muteIndicatorVisible = true;
      clearTimeout(this.muteTimeout);
      this.muteTimeout = setTimeout(() => {
        this.muteIndicatorVisible = false;
      }, 1500); // 1.5 seconds
    },
    async fetchVideos() {
      try {
        const response = await fetch('https://apps.programage.com/InshutiManager/tshaps.php');
        const result = await response.json();

        if (response.ok) {
          this.videos = result || [];
          this.videoLoaded = this.videos.map(() => false); // false = not loaded
        } else {
          alert('Failed to load videos.');
        }
      } catch (error) {
        alert('Error fetching videos: ' + error.message);
      }
    },
    scrollToIndex(index) {
      const el = this.reelRefs[index];
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    },
    toggleLike(index) {
      this.videos[index].liked = !this.videos[index].liked;
    },
    shareReel(index) {
      alert(`Share reel #${index + 1}`);
    },
    goToProfile(id) {
      router.push('/profile/' + id);
    },
    goTo(page) {
      if(page=='home'){
        router.push('/')
      }
      else if(page=='search'){
        router.push('/search/tshaps')
      }
      else{
        alert(`Navigate to: ${page}`);
      }      
    },
    handleFileChange(event) {      
      const file = event.target.files[0];
      if (!file) return;
      const videoElement = document.createElement('video');
      videoElement.preload = 'metadata';
      videoElement.onloadedmetadata = () => {
        window.URL.revokeObjectURL(videoElement.src);
        if (videoElement.duration > 90) {
          alert("Video is too long. Maximum allowed length is 90 seconds.");
          this.selectedFile = null;
          event.target.value = ''; // reset the input
        } else {
          this.selectedFile = file;
        }
      };
      videoElement.src = URL.createObjectURL(file);
    },
    openAddTshapModal() {
      this.isAddModalOpen = true;
    },
    closeAddTshapModal() {
      this.isAddModalOpen = false;
      this.newTshapCaption = '';
      this.selectedFile = null;
    },
    async uploadTshap() {
      if (!this.selectedFile || !this.newTshapCaption) {
        alert("Please provide a video and caption.");
        return;
      }

      this.isUploading = true;

      try {
        const formData = new FormData();
        formData.append('video', this.selectedFile);
        formData.append('caption', this.newTshapCaption);
        formData.append('user_id', this.id); // Replace with actual user ID if needed

        const response = await fetch('https://apps.programage.com/InshutiManager/tshaps.php', {
          method: 'POST',
          body: formData,
        });
        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.error || 'Upload failed');
        }

        this.videos.unshift({
          src: result.videoUrl,
          uploader: this.f_name+' '+this.l_name,
          caption: this.newTshapCaption,
          liked: false,
        });

        this.closeAddTshapModal();
      }catch (error) {
          alert(error.message+' Or Video processing you may close this dialog');
      } finally {
          this.isUploading = false;
          //Scroll back to the top
          this.scrollToTop();
      }
    },
    scrollToTop(){
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    handleWheel(e) {
      e.preventDefault();
      if (e.deltaY > 0 && this.currentIndex < this.videos.length - 1) {
        this.currentIndex++;
      } else if (e.deltaY < 0 && this.currentIndex > 0) {
        this.currentIndex--;
      }
      this.scrollToIndex(this.currentIndex);
    },
    handleTouchStart(e) {
      this.lastTouchY = e.touches[0].clientY;
    },
    handleTouchEnd(e) {
      const currentY = e.changedTouches[0].clientY;
      const deltaY = this.lastTouchY - currentY;
      if (deltaY > 50 && this.currentIndex < this.videos.length - 1) {
        this.currentIndex++;
      } else if (deltaY < -50 && this.currentIndex > 0) {
        this.currentIndex--;
      }
      this.scrollToIndex(this.currentIndex);
    },
    handleKeyDown(e) {
      if (e.key === 'ArrowDown' && this.currentIndex < this.videos.length - 1) {
        this.currentIndex++;
        this.scrollToIndex(this.currentIndex);
      } else if (e.key === 'ArrowUp' && this.currentIndex > 0) {
        this.currentIndex--;
        this.scrollToIndex(this.currentIndex);
      }
    },
    markVideoLoaded(index) {
      this.videoLoaded[index] = true;      
    }
  },
  mounted() {
    nextTick(async () => {
      await this.fetchVideos();         // Load videos
      await nextTick();                 // Wait for DOM updates

      const container = this.$refs.containerRef;
      this.containerRef = container;

      container.addEventListener('wheel', this.handleWheel, { passive: false });
      container.addEventListener('touchstart', this.handleTouchStart, { passive: false });
      container.addEventListener('touchend', this.handleTouchEnd, { passive: false });
      window.addEventListener('keydown', this.handleKeyDown);

      this.scrollToIndex(0); // Start at first video

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target.querySelector('video');
          if (entry.isIntersecting) {
            video?.play();
          } else {
            video?.pause();
          }
        });
      }, { threshold: 0.8 });

      this.reelRefs.forEach((el) => {
        if (el) observer.observe(el);
      });
    });
  },
  beforeUnmount() {
    const container = this.containerRef;
    container?.removeEventListener('wheel', this.handleWheel);
    container?.removeEventListener('touchstart', this.handleTouchStart);
    container?.removeEventListener('touchend', this.handleTouchEnd);
    window.removeEventListener('keydown', this.handleKeyDown);
  },
};
</script>
<style scoped>
/* Styles for video and modal */
.reels-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  position: relative;
}

.header {
  position: fixed;
  top: 0;
  width: 100%;
  color: white;
  text-align: left;
  padding: 10px;
  font-size: 20px;
  z-index: 10;
}

.reels-container {
  flex: 1;
  margin-top: 0px;
  margin-bottom: 60px;
  overflow: hidden;
}

.reel {
  position: relative;
  height: 100vh;
  scroll-snap-align: start;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.action-buttons {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 24px;
  pointer-events: auto;
}

.action-buttons button {
  background: none;
  border: none;
  font-size: 30px;
  color: white;
  cursor: pointer;
}

.liked {
  color: red;
}

.uploader-info {
  position: absolute;
  bottom: 80px;
  left: 16px;
  color: white;
  pointer-events: auto;
}

.user {
  display: flex;
  align-items: center;
  gap: 10px;
}

.follow-btn {
  padding: 4px 10px;
  font-size: 14px;
  background-color: #ff2e63;
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
}

.caption {
  margin-top: 6px;
  font-size: 14px;
  max-width: 80%;
}

.bottom-nav {
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 10px 0;
  z-index: 10;
}

.bottom-nav button {
  background: none;
  border: none;
  font-size: 24px;
  color: white;
  cursor: pointer;
}

.avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid white;
}

/* Add styles for the modal */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7); /* Dark overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 80%;
  max-width: 500px;
  position: relative;
  z-index: 1001;
  overflow: hidden;
}

textarea {
  width: 100%;
  height: 80px;
  margin-bottom: 10px;
}

button {
  padding: 10px;
  margin: 5px;
  background: #007bff;
  border: none;
  color: white;
  cursor: pointer;
}

button:hover {
  background: #0056b3;
}

.spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 8px solid #f3f3f3;
  border-top: 8px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.mute-indicator {
  position: absolute;
  top: 80px;
  right: 20px;
  font-size: 28px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border-radius: 50%;
  padding: 10px;
  z-index: 20;
  animation: fadeOut 1.5s ease forwards;
}

@keyframes fadeOut {
  0%   { opacity: 1; }
  80%  { opacity: 1; }
  100% { opacity: 0; }
}
.comments-panel {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60%;
  background: #fff;
  color: #000;
  z-index: 1001;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease-out forwards;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.comments-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #ddd;
}

.comments-header h3 {
  margin: 0;
  font-size: 18px;
}

.comments-body {
  padding: 16px;
  overflow-y: auto;
  flex: 1;
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}
.video-spinner {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 6px solid rgba(255, 255, 255, 0.3);
  border-top: 6px solid #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  z-index: 5;
}

@keyframes spin {
  to { transform: translate(-50%, -50%) rotate(360deg); }
}



</style>
